<template>
    <div class="classShare font16">
      
        
        <template v-if="!codeFlag">
          <template v-if="successFlag">
            <div class="top_div">
              <img src="../../assets/img/mine/yesLog.png" alt="">  
              <div class="bottom_word">加入成功</div>
            </div>
            <div class="btn-primary " @click="gotoUrl('routePage','',1)">返回</div>
          </template>
          <div v-else>
            <div class="class_bgc">
              <div class="class_title">班级邀请</div>
              <div class="join_title">{{classInfo.teacherName}}老师邀请你家孩子加入班级，请尽快加入班级</div>
              <div class="join_card font16">
                  <div><span class='gray'>学校：</span>{{classInfo.schoolName}}</div>
                  <div><span class='gray'>年级：</span>{{classInfo.gradeName}}</div>
                  <div><span class='gray'>班级：</span>{{classInfo.className}}</div>
              </div>
              <div class="join_list">
                <div class="list_title gray font16">请选择1个子女加入班级：</div>
                <van-radio-group v-model="selectChild" class="list_content">
                  <van-radio class="content_select" :name="item.studentId" v-for="item,index in childrenList" :key="item.studentId" :disabled="item.classId!=null">{{item.studentName}} &nbsp;({{sex[item.gender]}})<span class="also_enter" v-if="item.classId">已加入班级</span></van-radio>
                </van-radio-group>
                <a style="color: #0A59F7;text-decoration: underline;" @click="gotoUrl('unbind',{bindType:2})">添加子女</a>
              </div>
              
            </div>
            <div style="margin-top: 0.3rem;">
                <div class="btn-primary " @click="sureEnterClass">确定加入班级</div>
              </div>
          </div>
        </template>
        <div v-else class="footer_word">
          <div class="top_div"><img src="../../assets/img/mine/sharetimeout.png" alt=""></div>
          <div>链接已失效</div>
          <div>请联系班主任重新发送邀请链接</div>
        </div>
    </div>
  </template>
  <script>
    import {getInfoByInviteCode,getStudentByParent,joinClass} from '@/api/api.mine.js';
  
    export default {
      data() {
        return {
          classInfo:{},
          isShare:false,
          childrenList:[],
          selectChild:"",
          inviteCode:this.$route.query.inviteCode,
          successFlag:false,
          codeFlag:false,
          sex:['','男','女']
        }
      },
      created(){
        this.getClassInfo()
        this.getChildrenList()
      },  
      methods: {
        getClassInfo(){
          // getInfoByInviteCode({inviteCode:this.inviteCode})
          // getInfoByInviteCode({inviteCode:'8edb2ad38efc49f9b0269c94d989adbc'})
          getInfoByInviteCode({inviteCode:this.inviteCode}).then((res)=>{
            if(res.result==null){this.codeFlag=true}
            this.classInfo=res.result
          }).catch(()=>{
            this.codeFlag=true
          })
        },
        getChildrenList(){
          getStudentByParent({userId:this.loginUser.userId}).then((res)=>{
            this.childrenList=res.result
          })
        },
        sureEnterClass(){
          if(this.selectChild){
            joinClass({inviteCode:this.inviteCode,studentId:this.selectChild}).then((res)=>{
              this.successFlag=true
            })
          }else{

          }
          
        }
      },
    }
  </script>
  <style lang="scss" >
  .classShare{
font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
    padding:.12rem .15rem ;
    // padding-bottom: 1000px !important;
    .class_bgc{
      padding:.27rem .15rem .12rem;
      background: #FFFFFF;
      border-radius: 8px 8px 8px 8px;
      opacity: 1;
      background-color: #fff;
    }
    .class_title{
      width: 100%;
      text-align: center;
      font-size: 0.25rem;
      
      font-weight: 500;
      color: #0A59F7;
    }
    .top_div{
      margin-bottom: 0.5rem;
      margin-top: 0.6rem;
      font-size: 18px;
      font-weight: 600;
      color: #162746;
      width: 100%;
      line-height: 1.5rem;
      text-align: center;
      img{
        height: 1.2rem;
        width: 1.2rem;
        margin-bottom: 0;
      }
      .bottom_word{
        height: 19px;
        font-size: .16rem;
        
        font-weight: 400;
        color: rgba(0,0,0,0.6);
        line-height: 19px;
      }
    } 
    .join_title{
      margin-top: 0.2rem;
      font-size:.16rem;
      
      font-weight: 400;
      color: rgba(0,0,0,0.6);
    }
    .join_card{
      margin: 0.2rem 0;
      padding: .12rem .18rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: #EBF2FF;
      color:rgba(0,0,0,.9);
      border-radius:8px;
      line-height: .3rem;
      span{
        margin-right: .14rem;
      }
    }
    .join_list{
      .list_title{
        margin-bottom: 0.15rem;
      }
      .list_content{
        .content_select{
          margin-bottom: 0.2rem;
          display: flex;
          align-items: center;
        }
        .also_enter{
          background: rgba(0,0,0,0.5);
          border-radius: 2px;
          font-size:.11rem;
          padding:.02rem 0.04rem;
          color: #fff;
          margin-left: .1rem;
          display: inline-block;
        }
      }
    }
    .footer_word{
      text-align: center;
      font-size: 16px;
      
      font-weight: 400;
      color: rgba(0,0,0,0.6);
    }
  }
  
  </style>